import { useState, useRef, useEffect, useReducer, useContext } from 'react';
import './SmartCardInstall.scss';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import download from '../../../../../assets/icons/download-white.svg';
import checkmark from '../../../../../assets/icons/checkmark-white.svg';
import install from '../../../../../assets/img/install.gif';
import insert from '../../../../../assets/img/insert.gif';
import attach from '../../../../../assets/img/attach.gif';
import Ajax from '../../../../../Handler/Ajax';
import Toast from '../../../../Form/Toast';
import GovSpinner from '../../../../Form/GovSpinner';
// import ReCAPTCHA from 'react-google-recaptcha';
import SubmitBtn from '../../../../Form/submit-button/submit-button.component';
import eye from '../../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../../assets/icons/outline_eye_bright-off.svg';
import moviePlayer from '../../../../../assets/icons/movie-player.svg';
import alert from '../../../../../assets/icons/alert-circle-red.svg';
import alertYellow from '../../../../../assets/icons/alert-circle-yellow.svg';
import comSign from '../../../../../assets/img/comsign.png';
import tamuz from '../../../../../assets/img/tamuz-card.png';
import personalId from '../../../../../assets/img/personalID.png';
import externalLink from '../../../../../assets/icons/external-link-blue.svg';
import smartCard from '../../../../../assets/img/smart-card.svg';
import ZahavModal from '../../../../General/Static/Modal/Modal';
import bird from '../../../../../assets/img/not_registered_bird.png';
import LoginContext from '../../../../../store/login-context';


declare var _siteSettings: any;
declare var _loginMethodSmsOtpUrl: any;
declare function Translate(key: string): string;
declare var _curLang: any;
declare var _loginType: any;
declare var _loginTypeLoa4Landing: any;

const stepsReducer = (state, action) => {
  if(action.type === 'FIRST_STEP_DONE'){
    return {
      step1: {
        inactive: false,
        active: false,
        done: true
      },
      step2: {
        inactive: false,
        active: true,
        done: false,
      },
      step3: state.step3,
      step4: state.step4
    }
  }
  if(action.type === 'SECOND_STEP_DONE'){
    return {
      step1: state.step1,
      step2: {
        inactive: false,
        active: false,
        done: true
      },
      step3: {
        inactive: false,
        active: true,
        done: false
      },
      step4: state.step4
    }
  }
  if(action.type === 'THIRD_STEP_DONE'){
    return {
      step1: state.step1,
      step2: state.step2,
      step3: {
        inactive: false,
        active: false,
        done: true
      },
      step4: {
        inactive: false,
        active: true,
        done: false
      }
    }
  }
  if(action.type === 'FOURTH_STEP_DONE'){
    return {
      step1: state.step1,
      step2: state.step2,
      step3: state.step3,
      step4: {
        inactive: false,
        active: false,
        done: true
      }
    }
  }
};

const SmartCardInstall = props => {
  
  // let recaptchaRef:any = useRef(undefined);

  const ctx = useContext(LoginContext);

  const [stepsState, dispatchSteps] = useReducer(stepsReducer,{    
    step1: {
      inactive: false,
      active: true,
      done: false,
    },
    step2: {
      inactive: true,
      active: false,
      done: false,
    },
    step3: {
      inactive: true,
      active: false,
      done: false,
    },
    step4: {
      inactive: true,
      active: false,
      done: false,
    },    
  }); 

  const [stepImg, setStepImg] = useState(install);
  const [currentStep, setCurrentStep] = useState(1);
  const [codeValid, setCodeValid] = useState(false);  
  const [codeNumber, setCodeNumber] = useState('');  
  const [showDialog, setShowDialog] = useState(false);
  const [serverMessage, setServerMessage] = useState('');
  const [loading, setLoading] = useState(false);  
  const [userId, setUserId] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [readerOff, setReaderOff] = useState(false);
  const [isCardRemoved, setIsCardRemoved] = useState(false);
  const [controlType, setControlType] = useState('password');
  const [codeDirty, setCodeDirty] = useState(false);  
  const [notAllowedCard, setNotAllowedCard] = useState(false);
  const [issuerName, setIssuerName] = useState('');

  useEffect(() => {    
    if(ctx.devMode){
      setTimeout(() => firstStepDone(),1000);      
    }
    else{
      CheckInstalled();    
    }   
  },[]);

  useEffect(() => {
    if(showDialog){
      document.getElementById('okBtn')?.focus();    
    }
  },[showDialog])
  
  const downloadClick = () => {
    window.location.href = '/nidp/GOV/agents/SC_and_ID_Install.exe';    
  };
  
  const firstStepDone = () => {
    dispatchSteps({type:'FIRST_STEP_DONE'});
    setStepImg(attach);
    setCurrentStep(2);    

    if(ctx.devMode){
      setTimeout(() => secondStepDone(),1000);                
    }
  };

  const secondStepDone = () => {
    dispatchSteps({type:'SECOND_STEP_DONE'});
    setStepImg(insert);
    setCurrentStep(3);
    
    if(ctx.devMode){
      setTimeout(() => thirdStepDone(),1000);      
    }
    else{
      GetCard(); 
    }
  }

  const thirdStepDone = () => {
    dispatchSteps({type:'THIRD_STEP_DONE'});
    setStepImg(install);
    setCurrentStep(4);
    
    if(ctx.devMode){
      setTimeout(() => fourthStepDone(),1000);        
    }
  };

  const fourthStepDone = () => {
    dispatchSteps({type:'FOURTH_STEP_DONE'});
    setCurrentStep(5);
    setServerMessage('');    
  };

  const CheckInstalled = () => {
    Ajax.CheckInstalled()
      .then(() => {
        firstStepDone();   
        CheckAgent();
      })
      .catch(() => {
        setTimeout(CheckInstalled, 500);
      });
  };

  const CheckAgent = () => {
    Ajax.CheckAgent()
      .then(() => {
        secondStepDone();   
        startListenReaderRemove();
      })
      .catch(() => {
        setTimeout(CheckAgent, 500);
      });
  };

  const startListenReaderRemove = () => {
    Ajax.CheckReaderOff()
      .then(() => {
        setReaderOff(true);
        setServerMessage(Translate('N_General_Error_card reader_REMOVED'));        
        firstStepDone();
      })
      .catch(() => {
        if (readerOff) {
          setReaderOff(false);
          setServerMessage(Translate(''));          
        }
        setTimeout(startListenReaderRemove, 500);
      });
  };

  const GetCard = () => {
    Ajax.CheckCard()
      .then(() => {
        if(isCardRemoved){
          setIsCardRemoved(false);
          setServerMessage('');                   
        }
        thirdStepDone();        
        startListenCardremove();
        GetCardCertificat();
      })
      .catch(() => {
        setTimeout(GetCard, 500);
      });
  };

  const GetCardCertificat = () => {
    Ajax.GetCardCertificate()
      .then((data: any) => {
        setServerMessage('');
        //create custom event id for glassbox        
        if(data.userId.length === 9){         
          const gbDetector = window['_detector']; 
          if(gbDetector){
              gbDetector.triggerCustomEvent('userIsraeliIdLogin', data.userId);
          }
        }
        setUserId(data.userId);
        setFirstName(data.firstName);
        setLastName(data.lastName);  
        setIssuerName(data.issuerName);
        fourthStepDone();      
      })
      .catch((error) => {
        if(error !== undefined){   
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
        }
        setTimeout(GetCardCertificat, 500);
      });
  };

  const startListenCardremove = () => {
    Ajax.CheckRemovedCard().then(() => {
      setIsCardRemoved(true);
      setServerMessage(Translate('N_General_Error_CARD_REMOVED_ERRO_1')); 
      setNotAllowedCard(false);
      secondStepDone();
    });
  };

  const idCodeCheck = () => {
    setLoading(true);
    setServerMessage('');
    
    if (codeValid) {  
      if (ctx.devMode) {
        let neededInfo = [
          'email',
          'mobile',
          'password',
          'prefferedContactMethods',
        ];
        props.onProcessFinished(neededInfo);
      } else {
        Ajax.SignDummyChallange(codeNumber)
          .then(() => {
            // recaptchaRef.current.execute();
            onSolve();
          })
          .catch((error) => {            
            setLoading(false);
            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));            
          });
      }
    }
  };
 
  const handleDialogCancle = () => {
    setShowDialog(false);    
  };

  const handleDialogOk = () => {
    setShowDialog(false);
    secondStepDone();
  };

  const handleDialogShow = () => {
    setShowDialog(true);    
  };

  // const onExpired = () => {
  //   console.log('Captcha expired');
  // };

  const onSolve = () => {
    Ajax.GetChallangeFromServer()
      .then(() => {
        Ajax.SignChallange(codeNumber)
          .then(() => {
            Ajax.SendSigServer()
              .then(() => {
                Ajax.onPKILoginEnd()
                  .then((data: any) => {
                    setLoading(false);
                    if(issuerName === _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS || 
                        issuerName === _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS2 || 
                        issuerName === _siteSettings.validIssuers.PERSONALID_CARD_ISSUERS){
                          if (data.neededInfo !== undefined && data.neededInfo[0].trim().length === 0){
                            props.onProcessFinished(data.neededInfo);
                          }
                          else{
                            setNotAllowedCard(true);                             
                          }
                    }
                    else{
                      props.onProcessFinished(data.neededInfo);
                    } 
                    
                  })
                  .catch((error) => {
                    setLoading(false);                
                    setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
                  });
              })
              .catch((error) => {
                setLoading(false);                
                setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
                
                switch (error) {
                  case 'LOGON_PROCESS_EXPIRED':
                  case 'INTRUDER_DETECTED':
                  case 'AUTH_CONFIRM_TIMEOUT':
                  case 'SMARTPHONE_AUTH_REJECTED':
                  case 'SMARTPHONE_INCORRECT_LOCATION':
                  case 'TOTP_LOGON_DISABLED':
                  case 'LOGIN_DISABLED':
                  case 'PKI_LOGON_EXPIRED':
                    thirdStepDone();
                }
              });
          })
          .catch((error) => {            
            setLoading(false);
            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
          });
      })
      .catch((error) => {
        // recaptchaRef.current.reset();
        setLoading(false);
        setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
       
        switch (error) {
          case 'LOGON_PROCESS_EXPIRED':
          case 'INTRUDER_DETECTED':
          case 'AUTH_CONFIRM_TIMEOUT':
          case 'SMARTPHONE_AUTH_REJECTED':
          case 'SMARTPHONE_INCORRECT_LOCATION':
          case 'TOTP_LOGON_DISABLED':
          case 'LOGIN_DISABLED':
          case 'PKI_LOGON_EXPIRED':
            secondStepDone();
        }
      });
  };
  
  const cardEntered = () => {
    if(isCardRemoved){
      setIsCardRemoved(false);
      setServerMessage('');      
    }
    thirdStepDone();
    GetCardCertificat();
  }

  const handleCardCode = (e: React.ChangeEvent<HTMLInputElement>) => {  
    setCodeNumber(e.target.value);
    checkCodeNumber(e.target.value)          
  };

  const checkCodeNumber = (codeNumber) => {
    if (codeNumber.length > 3){
      setCodeValid(true); 
      document.getElementById("scCode")?.setAttribute("aria-invalid","false");     
    } else {
      setCodeValid(false); 
      document.getElementById("scCode")?.setAttribute("aria-invalid","true");
    }
  };

  const handleCardCodeEnter = (event) => {
    if (event.charCode === 13) {
      event.preventDefault();
      idCodeCheck();
    }
  }

  const onPinCodeBlur = () => {
    if(codeNumber.length > 0 && !codeDirty){
      setCodeDirty(true);
    }
  }
       
  const forwardToRegForm = (event) => {
    //event.preventDefault();
    window.location.href = _siteSettings.signupLink;
  }  

  const goToOldProcess = () => {
    _loginType = _loginTypeLoa4Landing;
    ctx.toggleCard();  
    ctx.scSelected();  
  };

  const onKeyOldProcess = (event) => {
    if (event.charCode === 13){
      goToOldProcess();
    }
  };

  return (
    <Container fluid>
      <div>
        {/* <ReCAPTCHA
          ref={recaptchaRef as any}
          sitekey={_siteSettings.recaptchaSiteKey}
          onChange={onSolve}
          onExpired={onExpired}
          size='invisible'
        /> */}
      </div>

      {notAllowedCard && 
        <ZahavModal>
          <div className='sc-install-modal-container'>
            <div>
              <img src={bird} width={483} height={267} />
            </div>
            <div className='sc-install-modal-title'>                              
              {Translate('N_Login_biometric_id_registration_info_3')}            
            </div>
            <div className='sc-install-modal-content'>
              {Translate('N_Login_biometric_id_registration_info_4')}  
            </div>
            <div className='sc-install-modal-btn-container'>
              <button
                type='button'
                className='sc-install-modal-reg-btn'
                onClick={forwardToRegForm}
              >
                {Translate('N_General_SignUp_butten')}
              </button>
            </div>
            <div className='sc-install-modal-link-container'>
              <a href={_loginMethodSmsOtpUrl} >{Translate('N_General_cancel_butten')}</a>
            </div>

          </div>
        </ZahavModal>
      }

      {serverMessage.length > 0 && (
        <Row>
          <Col xs={10}>
            <Toast message={serverMessage} />
          </Col>
        </Row>
      )}

      <GovSpinner show={loading} />          
      {currentStep !== 5 ? (
        <Row className='d-flex justify-content-center'>
          <Col xl={10} lg={10} md={10} sm={12} xs={12}>
            <Row className='x-large form-font'>
              {Translate('N_Login_SmartCard_software_installation_title')}
            </Row>
            <Row className='regular form-font'>
              {Translate('N_Login_SmartCard_software_installation_info')}
            </Row>
            <Row
              className={
                stepsState!.step1.active
                  ? 'mt-4 align-items-start'
                  : 'mt-4 align-items-center'
              }
            >
              <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
                {stepsState!.step1.active ? (
                  <div className='circle-step'>1</div>
                ) : stepsState!.step1.inactive ? (
                  <div className='circle-step-inactive'>1</div>
                ) : (
                  <div className='circle-step-succeeded'>
                    <span className='checkmark-icon'>
                      <img src={checkmark}  />
                    </span>
                  </div>
                )}
              </Col>
              <Col xs={5}>
                <Row
                  className={
                    stepsState!.step1.active
                      ? 'font-active-step-title'
                      : 'form-font-inactive'
                  }
                >                   
                  {Translate('N_Login_Bio_ID_software_installation_step_1')}
                </Row>
                {stepsState!.step1.active && (
                  <>
                    <Row className='regular font-active-step-text'>                      
                      {Translate(
                        'N_Login_SmartCard_software_installation_step_1_info_card'
                      )}
                    </Row>
                    {/* <Row className="d-flex flex-row justify-content-start align-items-center mt-2 smart-card-movie">
                      <img src={moviePlayer} alt="movie player" width="20px" height="14px"/>&nbsp;&nbsp;
                      <a href='https://youtu.be/uwQPK-G7VC8' target='_blank' rel="noopener noreferrer" className='regular'>                
                        {Translate('N_Login_SmartCard_software_installation_step_1_info_movie')}
                      </a> 
                    </Row>  */}
                    <Row>
                      <Col
                        xl={10}
                        lg={10}
                        md={10}                        
                        className='pe-0 pt-2 mt-2'
                      >
                        <button
                          type='button'
                          id='downloadNetIqSoftBtn'
                          className='download_btn'
                          onClick={downloadClick}
                        >
                          <span className='icon_container' aria-hidden="true">
                            <img src={download}  />
                          </span>
                          <span>
                            {Translate(
                              'N_Login_Bio_ID_software_installation_button'
                            )}
                          </span>
                        </button>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
              {stepsState!.step1.active && (
                <Col lg={5} className="d-none d-lg-block" aria-hidden="true">
                  <img
                      src={stepImg}
                      
                      width='330px'
                      height='230px'                        
                  />
                </Col>
              )}
            </Row>
            <Row className={
                stepsState!.step2.active
                  ? 'mt-4 align-items-start'
                  : 'mt-4 align-items-center'
              }>
              <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
                {stepsState!.step2.active ? (
                  <div className='circle-step'>2</div>
                ) : stepsState!.step2.inactive ? (
                  <div className='circle-step-inactive'>2</div>
                ) : (
                  <div className='circle-step-succeeded'>
                    <span className='checkmark-icon'>
                      <img src={checkmark}  />
                    </span>
                  </div>
                )}
              </Col>
              <Col xs={5}>
                {stepsState!.step2.active ? (
                  <>
                    <Row className='font-active-step-title'>                      
                      {Translate(
                        'N_Login_Bio_ID_software_installation_step_2'
                      )}
                    </Row>
                    <Row className='regular font-active-step-text'>                      
                      {Translate(
                        'N_Login_Bio_ID_software_installation_step_2_info'
                      )}
                    </Row>
                  </>
                ) : (
                  <Row className='regular form-font-inactive '>                      
                    {Translate('N_Login_Bio_ID_software_installation_step_2')}
                  </Row>
                )}
              </Col>
              {stepsState!.step2.active && (
              <Col lg={5} className="d-none d-lg-block" aria-hidden="true">
                <img
                    src={stepImg}
                    
                    width='221px'
                    height='171px'                      
                />
              </Col> 
              )}
            </Row>
            <Row
              className={
                stepsState!.step3.active
                  ? 'mt-4 align-items-start'
                  : 'mt-4 align-items-center'
              }
            >
              <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
                {stepsState!.step3.active ? (
                  <div className='circle-step'>3</div>
                ) : stepsState!.step3.inactive ? (
                  <div className='circle-step-inactive'>3</div>
                ) : (
                  <div className='circle-step-succeeded'>
                    <span className='checkmark-icon'>
                      <img src={checkmark}  />
                    </span>
                  </div>
                )}
              </Col>
              <Col xs={5}>
                <Row
                  className={
                    stepsState!.step3.active
                      ? 'font-active-step-title'
                      : 'regular form-font-inactive'
                  }
                >                    
                  {Translate('N_Login_SmartCard_software_installation_step_3')}
                </Row>
                {stepsState!.step3.active && (
                  <>
                    <Row className='regular font-active-step-text'>                      
                      {Translate('N_Login_SmartCard_software_installation_step_3_nfo')}
                    </Row>
                    <Row>
                      <Col
                        xl={10}
                        lg={10}
                        md={10}                         
                        className='pe-0 pt-2'
                      >
                        <button
                          id='insertCardBtn'
                          type='button'
                          className='download_btn'
                          onClick={cardEntered}
                        >                           
                          <span>                              
                            {Translate('N_Login_SmartCard_software_installation_step_3_butten')}
                          </span>
                        </button>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
              {stepsState!.step3.active && (
                <Col lg={5} className="d-none d-lg-block" aria-hidden="true">
                  <img
                      src={stepImg}
                      
                      width='274px'
                      height='189px'                        
                  />
                </Col>
              )}
            </Row>
            <Row className={'mt-4 ' + 
                (stepsState!.step4.active
                  ? 'align-items-start'
                  : 'align-items-center' )
              }>
              <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
                {stepsState!.step4.active ? (
                  <div className='circle-step'>4</div>
                ) : stepsState!.step4.inactive ? (
                  <div className='circle-step-inactive'>4</div>
                ) : (
                  <div className='circle-step-succeeded'>
                    <span className='checkmark-icon'>
                      <img src={checkmark}  />
                    </span>
                  </div>
                )}
              </Col>
              <Col xs={11}>
                <Row
                  className={
                    stepsState!.step4.active
                      ? 'font-active-step-title'
                      : 'regular form-font-inactive'
                  }
                >                   
                  {Translate('N_Login_SmartCard_software_installation_step_4')}
                </Row>
                {stepsState!.step4.active && (
                  <>
                  <Row className='regular install-desc'>
                    <span>
                    {Translate('N_Login_SmartCard_software_installation_step_4_info1')}
                    </span>
                    <a className='link' target='_blank' href='https://www.gov.il/he/Departments/Guides/smart_card'>
                      <span className='mx-1 d-flex align-items-center'>{Translate('N_Login_biometric_id_SmartCard_guide')}
                        <img src={externalLink} className='mx-1' width="14px" height="14px" />
                      </span>
                    </a>                     
                  </Row>  
                  <Row>  
                    <Col md={7} xl={6}>                                
                      <Row className="install-alert mb-8 py-2"> 
                          <Col xs={1} aria-hidden="true">
                            <img src={alertYellow} />
                          </Col>
                          <Col xs={10}>
                            {Translate('N_Login_Bio_ID_software_installation_step_4_info2')}
                          </Col>                        
                      </Row>
                    </Col> 
                  </Row>                                      
                  </>
                )}
              </Col>
            </Row> 
            <Row >
              <Col className='mt-5 d-none d-md-block d-lg-none' aria-hidden="true">
                <div className='d-flex justify-content-center'> 
                  <img
                    src={stepImg}
                    alt=''
                    width='340pt'
                    height='240pt'                    
                  />
                </div>
              </Col>
            </Row>  
            {/* To old version link  */}
            {/* <Row className='d-flex align-items-center old-sc-version-container mt-5 mb-5'>
              <div className='old-sc-version'>{Translate('N_Login_smart_card_problem')} </div>
              <div 
                id='toOldVersionLink'
                className='old-sc-version-link'
                tabIndex={0}
                onClick={goToOldProcess}
                onKeyPress={onKeyOldProcess}
              >
                  <span>{Translate('N_Login_smart_card_back_old_version')}</span>                                   
              </div> 
            </Row>  */}
          </Col>
        </Row>
      ) : (
        <>
          <Row className='d-flex justify-content-center mt-5'>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              <div className='text-center mb-4' aria-hidden="true">
                <img src={smartCard}  width='84px' height='54px' />
              </div>
              <div className='x-large dark-blue text-center font-weight-bold' role="heading" aria-level={1}>
                {Translate('N_Login_Bio_ID_name title')}{' '}
                {`${firstName} ${lastName}`}
              </div>
              <div className='regular dark-blue text-center'>
                {Translate('N_Login_Bio_ID_OTP_info_1')} {userId}
              </div>
              <div id='lblOtp' className='medium dark-blue text-center mt-4 mb-2 font-weight-500'>                  
                {Translate('N_Login_SmartCard_OTP_info_2')}
              </div>
              <Form className='normal-form'>
                <Row className='justify-content-center'>
                  <Form.Group as={Col} xl={8} lg={8} md={12} sm={12} xs={12} className="input_wrapper">   
                    <Form.Label className='my-1 d-flex align-items-center justify-content-between' aria-hidden="true">
                      <div>
                        &nbsp;                                        
                      </div>
                      <div 
                        className='mx-2 d-flex align-items-center'
                        onClick={() =>
                          setControlType(
                            controlType === 'password'
                              ? 'text'
                              : 'password'
                          )
                        }
                      >
                        <img
                          src={controlType === 'password' ? eye : eyeOff}
                          width='22px'
                          height='18px'
                          
                          role='button'
                          tabIndex={0}
                          className={
                            codeNumber
                              ? 'mx-1 password-view-show'
                              : 'mx-1 password-view-hide'
                          }
                          
                        />
                        <span 
                          className={
                            codeNumber
                              ? 'password-view-show'
                              : 'password-view-hide'
                          }
                        >
                          {controlType === 'password' 
                            ? Translate('N_General_SignUp_info_18')
                            : Translate('N_General_SignUp_info_19')
                          }
                        </span>                      
                      </div>
                    </Form.Label>              
                    <Form.Control
                      id='scCode'
                      autoFocus
                      aria-required="true"
                      aria-labelledby="lblOtp"
                      aria-invalid="false"
                      aria-errormessage="otpError"                       
                      type={controlType}
                      value={codeNumber}
                      onChange={handleCardCode}
                      onKeyPress={handleCardCodeEnter}
                      onBlur={onPinCodeBlur}
                      className={`otp_input gov-black
                        ${(!codeValid && codeDirty)
                          ? ' error-control'
                          : ''
                        }
                      `}
                    />                   
                  </Form.Group>
                </Row>
                {codeDirty && !codeValid && (
                  <Row  className='justify-content-center'> 
                    <div className='d-flex align-items-center col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'>
                      <img src={alert}  className='error-alert' />
                      &nbsp;
                      <span id='otpError' className='regular error sc_code_err'>
                        {Translate('N_General_Error_Card_PIN_too short')}
                      </span>
                    </div>
                  </Row>
                )}
                
                <Row className='justify-content-around sc_code_button_wrapper'>
                  <Col xs={8}>                     
                    <SubmitBtn
                      title={Translate('N_Login_Bio_ID_OTP_button_1')}
                      id="scInstallSubmit"
                      action={idCodeCheck}
                      showIcon={false}
                      disabled={!codeValid}
                    />
                  </Col>
                </Row>
                <Row className='justify-content-center mt-5'>
                  <Col xs={11} className='text-center'>
                    <Button
                      id = 'changeCardBtn'                   
                      variant='link'
                      onClick={handleDialogShow}
                      className='regular font-weight-500'
                    >                        
                      {Translate('N_Login_SmartCard_OTP_button_2')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>

          <Modal
            show={showDialog}
            onHide={handleDialogCancle}
          >          
            <Modal.Body>
              <Row>                  
                <Col xs={12}>
                  <div className='text-center dialog-title mt-5' role="heading" aria-level={2}>
                    {Translate(
                      'N_Login_SmartCard_software_installation_error2_title'
                    )}
                  </div>
                  <div className='text-center mt-3 dialog-info'>
                    {Translate(
                      'N_Login_SmartCard_software_installation_error2_info'
                    )}
                  </div>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer className='mb-3'>
              <Col xs={8}>
                <Row>
                  <Button
                    id='okBtn'
                    variant='primary'
                    className='w-100'
                    onClick={handleDialogOk}
                  >
                    {Translate('N_Login_Bio_ID_software_installation_error_butten')}
                  </Button>
                </Row>
                <Row className='mt-2'>
                  <Button
                    variant='link'
                    className='w-100'
                    onClick={handleDialogCancle}
                  >
                    {Translate('N_General_cancel_butten')}
                  </Button>
                </Row>
              </Col>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Container>
  );

};
export default SmartCardInstall;

